// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4223) return "static/chunks/commons-38eb820a2d5dd37a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3046 ? "splide" : chunkId) + "." + {"3046":"0846e9ba123f92f9","3219":"119348f8dbbe316b","8538":"908dd330e52f0dfe"}[chunkId] + ".js";
};